export default {
  name: "dashboard-guide-card",
  components: {},
  props: [],
  data() {
    return {
      dashboardGuideLoader: true
    };
  },
  computed: {},
  mounted() {
    setTimeout(() => {
      this.dashboardGuideLoader = false;
    }, 1000);
  },
  methods: {}
};
